<template>
    <div>
        This is for the , floors set up interface.
    </div>
</template>

<script>
  export default {
    name: 'Floor',
  };
</script>

<style scoped>

</style>